import { useState } from 'react';

import { useQueryClient } from '@tanstack/react-query';
import { useNavigate } from '@tanstack/react-router';
import { ContextMenu, type ContextMenuItem } from 'cpool-components/general/ContextMenu';
import { useTranslation } from 'react-i18next';
import { LuSettings } from 'react-icons/lu';

import { SettingsModal } from './SettingsModal';
import { HeaderButton } from '../../../HeaderButton';
import { APICommunicator } from '~/api/APICommunicator';
import useUserInfo from '~/hooks/useUserInfo.tsx';

const UserSettings = () => {
    const { t } = useTranslation();
    const userInfo = useUserInfo();
    const navigate = useNavigate();
    const queryClient = useQueryClient();

    const [isSettingsModalOpen, setIsSettingsModalOpen] = useState(false);

    const userName =
        userInfo && userInfo.firstName && userInfo.lastName
            ? `${userInfo.firstName} ${userInfo.lastName}`
            : t('TOP_HEADER.USER_SETTINGS.UNKNOWN_USER');

    const items: ContextMenuItem[] = [
        {
            id: 'settings',
            label: t('TOP_HEADER.USER_SETTINGS.SETTINGS.TITLE'),
            onClick: () => setIsSettingsModalOpen(true),
        },
        {
            id: 'support',
            label: t('TOP_HEADER.USER_SETTINGS.SUPPORT'),
        },
        {
            id: 'licence',
            label: t('TOP_HEADER.USER_SETTINGS.LICENCE'),
        },
        {
            id: 'logout',
            label: t('TOP_HEADER.USER_SETTINGS.LOGOUT'),
            onClick: async () => {
                queryClient.clear();
                await APICommunicator.logout();
                navigate({ to: '/login' });
            },
        },
    ];

    return (
        <>
            <ContextMenu
                items={items}
                trigger={
                    <HeaderButton iconLeft={<LuSettings />}>
                        <span className="hidden lg:inline-block">{userName}</span>
                    </HeaderButton>
                }
            />
            {/* kept mounted so the side modal can slide in and out — see SettingsModal */}
            <SettingsModal open={isSettingsModalOpen} onClose={() => setIsSettingsModalOpen(false)} />
        </>
    );
};

export default UserSettings;
